import { MapContainer, TileLayer, Marker, Popup, GeoJSON } from "react-leaflet";
import { useEffect, useState } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

import { MapRequest } from "./request";
import { Divider } from "antd";

delete L.Icon.Default.prototype._getIconUrl;

const position = [-15.793889, -47.882778];

export const Mapa = () => {
  const [markers, setMarkers] = useState([
    {
      latitude: 0,
      longitude: 0,
      nome_cartorio: "",
      cidade: "",
      uf: "",
      em_aberto: false,
      qtde_licenca: 0,
    },
  ]);

  const [geojsonData, setGeojsonData] = useState(null);

  useEffect(() => {
    mapGet();
  }, []);

  const mapGet = async () => {
    const response = await MapRequest.getGeoLoc();
    if (response.status === 200) {
      setMarkers(response.data);
    }
  };

  const MAPTILER_KEY = process.env.REACT_APP_MAPTILER_KEY;

  useEffect(() => {
    fetch("/br_estados.geojson")
      .then((res) => res.json())
      .then((data) => setGeojsonData(data))
      .catch((err) => console.error("Erro ao carregar GeoJSON", err));
  }, []);

  const isMobile = window.innerWidth < 768 || window.devicePixelRatio > 1.5;
  const size = isMobile ? 20 : 30;

  const redIcon = (color) =>
    new L.divIcon({
      className: "",
      html: `
    <svg width="28" height="42" viewBox="0 0 40 60">
        <path
            d="M20 0C9 0 0 9 0 20C0 30 20 60 20 60C20 60 40 30 40 20C40 9 31 0 20 0Z"
            fill="${color}"
            stroke="white"
        />
        <circle cx="20" cy="20" r="6" fill="white" />
    </svg>
    `,
      iconSize: [size, size * 1.64],
      iconAnchor: [size / 2, size * 1.64],
      popupAnchor: [1, -size],
    });

  return (
    <div style={{ height: "100vh", width: "100%" }}>
      <MapContainer
        center={position}
        zoom={4}
        style={{ height: "100%", width: "100%" }}
      >
        <TileLayer
          url={`https://api.maptiler.com/maps/streets-v2/256/{z}/{x}/{y}.png?key=${MAPTILER_KEY}`}
          attribution='&copy; <a href="https://www.maptiler.com/copyright/">MapTiler</a>'
        />

        {markers.map((marker, index) => (
          <Marker
            key={index}
            position={[marker.latitude, marker.longitude]}
            icon={redIcon(marker.em_aberto ? "#E63946" : "#003F88")}
          >
            <Popup>
              {marker.nome_cartorio}{" "}
              <Divider style={{ padding: 0, margin: "4px 0px 4px 0px" }} />
              {marker.cidade} - {marker.uf}
              <Divider style={{ padding: 0, margin: "4px 0px 4px 0px" }} />
              Quantidade de Licenças: {marker.qtde_licenca}
            </Popup>
          </Marker>
        ))}

        {geojsonData && (
          <GeoJSON
            data={geojsonData}
            style={{ color: "blue", weight: 2, fillOpacity: 0 }}
          />
        )}
      </MapContainer>
    </div>
  );
};
